/* eslint-disable ngrx/prefer-inline-action-props */
import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';

const namespace = '[CLIENT_ENTITIES]';

export interface ClientEnitiesPayload {
  clientUuid: string;
  entity_name: string;
  data?: any;
}

export const PlFetchClientEntities = createAction(
  `${namespace} Fetch`,
  props<ClientEnitiesPayload>()
);
export const PlAddClientEntity = createAction(
  `${namespace} Add`,
  props<ClientEnitiesPayload>()
);
export const PlEditClientEntity = createAction(
  `${namespace} Edit`,
  props<ClientEnitiesPayload>()
);
export const PlDeleteClientEntity = createAction(
  `${namespace} Delete`,
  props<ClientEnitiesPayload>()
);
export const PlClientEntityAddedSuccessfully = createAction(
  `${namespace} Added Successfully`,
  props<ClientEnitiesPayload>()
);
export const PlDeleteClientObjective = createAction(
  `${namespace} Delete Objective`,
  props<{ clientUuid: string; objectiveUuid: string }>()
);

export const PlDeleteSessionObjective = createAction(
  `${namespace} Delete Session Objective`,
  props<{
    clientUuid: string;
    eventUuid: string;
    sessionUuid: string;
    sessionObjectiveUuid: string;
  }>()
);

export const PlFetchClientSessions = createAction(
  `${namespace} Fetch Sessions`,
  props<{
    clientUuid: string;
    start: DateTime;
    end: DateTime;
    iepId?: string;
  }>()
);
